var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5136 16.5557L18.483 14.5551M18.3852 20.6765L14.452 18.5588M22.5 13.6176C22.5 14.7872 21.5519 15.7353 20.3824 15.7353C19.2128 15.7353 18.2647 14.7872 18.2647 13.6176C18.2647 12.4481 19.2128 11.5 20.3824 11.5C21.5519 11.5 22.5 12.4481 22.5 13.6176ZM14.7353 17.5C14.7353 18.6695 13.7872 19.6176 12.6176 19.6176C11.4481 19.6176 10.5 18.6695 10.5 17.5C10.5 16.3305 11.4481 15.3824 12.6176 15.3824C13.7872 15.3824 14.7353 16.3305 14.7353 17.5ZM22.5 21.3824C22.5 22.5519 21.5519 23.5 20.3824 23.5C19.2128 23.5 18.2647 22.5519 18.2647 21.3824C18.2647 20.2128 19.2128 19.2647 20.3824 19.2647C21.5519 19.2647 22.5 20.2128 22.5 21.3824Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/icon_share.4fa4042d17def06202fad08312888584.svg";
export { ForwardRef as ReactComponent };